import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { WorkWeekService } from 'src/app/services/work-week.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-paycard',
  templateUrl: './paycard.component.html',
  styleUrls: ['./paycard.component.scss']
})
export class PaycardComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  hasPaycard:number = -1;
  payCardNumber:number = 0;
  
  constructor(
    public alertDialog: MatDialog,
    private workweekservice: WorkWeekService,
    private currentorderservice: CurrentOrderService,
    private currentinfoservice: CurrentInfoService,
    private initializationservice: InitializationService,
    private route: ActivatedRoute,
    private router: Router,
    private navigationservice: NavigationService,
    private localeserice: LocaleService,
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    var payCardData = this.currentorderservice.getPayCardData();

    this.hasPaycard = payCardData.hasPayCard;
    this.payCardNumber = payCardData.payCardNumber;
  }

  back()
  {
    this.navigationservice.back();
  }

  setHasPayCard(status:number)
  {
    this.hasPaycard = status;
  }

  check()
  {
    if(this.hasPaycard === -1)
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeserice.instantTranslation("Dialogs.Alert.PayCardWarning.Title"), 
          detail:this.localeserice.instantTranslation("Dialogs.Alert.PayCardWarning.Detail"), 
          accept:this.localeserice.instantTranslation("Dialogs.Alert.PayCardWarning.Accept") 
        }
      });

      return false;
    }

    if(this.hasPaycard === 1 && this.payCardNumber < 1)
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeserice.instantTranslation("Dialogs.Alert.PayCardNumberWarning.Title"), 
          detail:this.localeserice.instantTranslation("Dialogs.Alert.PayCardNumberWarning.Detail"), 
          accept:this.localeserice.instantTranslation("Dialogs.Alert.PayCardNumberWarning.Accept") 
        }
      });

      return false;
    }

    return true;
  }

  goOn()
  {
    if(this.check())
    {
      var data = { hasPayCard: this.hasPaycard, payCardNumber: this.payCardNumber};

      this.currentorderservice.setPayCardData(data)

      var appname = String(this.route.snapshot.paramMap.get('appname'));

      this.router.navigateByUrl('/' + appname + '/orderresume');
    }
  }
}